import { Download } from '@mui/icons-material'
import { Grid, Icon, Link } from '@mui/material'

export const FormUploadFilesPrint = ({ value = [], title, ...props }) => {
  return (
    <>
      {value.map((file, index) => {
        return (
          <Link
            key={index}
            href={file.url}
            target='_blank'
            rel='noreferrer'
            sx={{
              paddingLeft: '5px',
              marginTop: index === 0 && '8px',
              marginBottom: index === value.length - 1 ? '0px' : '10px'
            }}
          >
            <Grid container alignItems='center'>
              <Icon
                style={{
                  width: 28
                }}
              >
                <Download />
              </Icon>
              {file.name}
            </Grid>
          </Link>
        )
      })}
    </>
  )
}
